import { MuiTelInput, MuiTelInputCountry } from "mui-tel-input"
import { useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { FormErrors } from "./form"
/**
 * AREA SEPA
 * codici ISO 3166-1 alpha-2
 */
const sepaCountries: MuiTelInputCountry[] = [
	"AT", // Austria
	"BE", // Belgio
	"BG", // Bulgaria
	"HR", // Croazia
	"CY", // Cipro
	"CZ", // Repubblica Ceca
	"DK", // Danimarca
	"EE", // Estonia
	"FI", // Finlandia
	"FR", // Francia
	"DE", // Germania
	"GR", // Grecia
	"HU", // Ungheria
	"IS", // Islanda
	"IE", // Irlanda
	"IT", // Italia
	"LV", // Lettonia
	"LI", // Liechtenstein
	"LT", // Lituania
	"LU", // Lussemburgo
	"MT", // Malta
	"MC", // Monaco
	"NL", // Paesi Bassi
	"NO", // Norvegia
	"PL", // Polonia
	"PT", // Portogallo
	"RO", // Romania
	"SM", // San Marino
	"SK", // Slovacchia
	"SI", // Slovenia
	"ES", // Spagna
	"SE", // Svezia
	"CH", // Svizzera
	"GB", // Regno Unito
	"VA", // Città del Vaticano
	"ME", // Montenegro
]

const SepaPhoneNumberInput = ({
	label,
	errorsList,
	field,
	setErrorsList,
	disabled,
	handleChange,
	phoneValue,
}: {
	label: string
	errorsList: FormErrors | undefined
	field: string
	setErrorsList: (newErrorsList: FormErrors | undefined) => void
	disabled: boolean
	handleChange: (field: string) => Function
	phoneValue: string | undefined
}) => {
	const [value, setValue] = useState<string | undefined>(undefined)
	const { t } = useTranslation()
	useEffect(() => {
		setValue(phoneValue)
	}, [phoneValue])

	const handleChangePhone = useCallback(
		(newPhoneValue: string) => {
			setValue(newPhoneValue)
			handleChange(field)(newPhoneValue)
		},
		[handleChange, field]
	)

	return (
		<MuiTelInput
			label={label}
			onChange={(newPhone) => handleChangePhone(newPhone)}
			error={Boolean(errorsList && errorsList[field])} // Mostra errore solo se presente
			helperText={
				errorsList && errorsList[field]
					? t(errorsList[field], { ns: "userMenu" })
					: ""
			} // Messaggio di errore
			defaultCountry="IT"
			forceCallingCode
			value={value}
			disabled={disabled}
			onlyCountries={sepaCountries}
		/>
	)
}

export default SepaPhoneNumberInput
